module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "price-range"
  }, [_c('money', {
    staticClass: "form-control start",
    model: {
      value: (_vm.start),
      callback: function($$v) {
        _vm.start = $$v
      },
      expression: "start"
    }
  }), _vm._v(" - "), _c('money', {
    staticClass: "form-control end",
    model: {
      value: (_vm.end),
      callback: function($$v) {
        _vm.end = $$v
      },
      expression: "end"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b474d594!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PriceRange.vue
// module id = 1346
// module chunks = 2